import { render, staticRenderFns } from "./EnacAtplDashboardFlightFollowUpLearners.vue?vue&type=template&id=70c1bec0"
import script from "./EnacAtplDashboardFlightFollowUpLearners.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardFlightFollowUpLearners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports